import HttpRequest from './HttpRequest';

export default class ManagerService extends HttpRequest {
  static endpoint = 'managers';

  static async getAll() {
    this.endpoint = 'partners/own-managers';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'managers';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'managers';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'managers';
    const response = await this.put(id, data);
    return response;
  }

  static async toggleIsOrderTaker(id) {
    this.endpoint = 'managers/toggle/is-order-taker';
    const response = await this.put(id, {});
    return response;
  }

  static async remove(id) {
    this.endpoint = 'managers';
    const response = await this.delete(id);
    return response;
  }

  static async uploadImage(data) {
    this.endpoint = 'managers/create-avatar';
    const response = await this.post(data);
    return response;
  }

  static async deleteImage(data) {
    this.endpoint = 'products/delete-avatar';
    const response = await this.delete(data);
    return response;
  }
}
